<script setup lang="ts">
import RailNav from '@/components/RailNav.vue'
import TopBar from '@/components/TopBar.vue'
import Toasts from '@/components/Toasts.vue'
import InboxPanel from '@/components/InboxPanel.vue'
import PersonPopover from '@/components/PersonPopover.vue'
import KnockModal from '@/components/KnockModal.vue'
import KnowledgeViewer from '@/components/KnowledgeViewer.vue'
import MiniCall from '@/components/MiniCall.vue'
import DevPanel from '@/components/DevPanel.vue'
import { useNotify } from '@/stores/notify'
import { usePrefs } from '@/stores/prefs'
import { useUi } from '@/stores/ui'

const notify = useNotify()
const prefs = usePrefs()
const ui = useUi()
</script>

<template>
  <div class="shell">
    <RailNav />
    <div class="shell__main">
      <TopBar />
      <main class="content"><slot /></main>
    </div>
  </div>

  <!-- overlays -->
  <Toasts />
  <MiniCall />
  <InboxPanel v-if="notify.inboxOpen" />
  <PersonPopover />
  <KnockModal />
  <KnowledgeViewer />
  <DevPanel v-if="prefs.dev && ui.devPanel" />
</template>
